/**
 * 全局常量、方法封装模块
 * 通过原型挂载到Vue属性
 * 通过 this.Global 调用
 */

// 后台管理系统服务器地址
//export const baseUrl = 'http://dev.doll-yang.com/api/v2'
export const baseUrl = 'https://wxapi.xiyouji.pro/api/v2'

// 系统数据备份还原服务器地址
export const backupBaseUrl = ''
//后台网址
//export const backDoMain = 'http://dev.doll-yang.com/'
export const backDoMain = 'https://www.xiyouji.pro/'
export default {
    baseUrl,
    backupBaseUrl,
    backDoMain
}


// WEBPACK FOOTER //
// ./src/utils/global.js